import {
  getHtmlElement,
  renderWebComponent, setHtmlElementAttribute,
  string2obj
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';


export class ImageComponent extends HTMLElement {
  props = {};

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
  }

  render() {
    const html = `     
      <img id="image" alt="" src=""/>         
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles]);

    const img = getHtmlElement(this.shadowRoot, 'image');
    img.setAttribute('src', this.props.url)
    if (this.props.additional_classes)
      img.setAttribute("class", this.props.additional_classes);
  }
}

window.customElements.define("image-component", ImageComponent);